module.exports = __webpack_public_path__ + "static/img/tongyi.d8eba898.png";